import { render, staticRenderFns } from "./TheDot.vue?vue&type=template&id=1b223310&"
import script from "./TheDot.vue?vue&type=script&lang=js&"
export * from "./TheDot.vue?vue&type=script&lang=js&"
import style0 from "./TheDot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports